import { useCampaignCode } from '@campaign-services/hooks/useCampaignCode'
import { useApiCampaignActivityInfo } from '@hooks-api/fortune/useApiCampaignActivityInfo'
import { useApiCampaignMember } from '@hooks-api/fortune/useApiCampaignMember'
import { CampaignStatus } from '@hooks-api/types/dataModel/campaigns'
import { ButtonBase } from '@pets-ui/ButtonBase/ButtonBase'
import { HStack } from '@pets-ui/HStack/HStack'
import { IconButton } from '@pets-ui/IconButton/IconButton'
import { UserOutlined } from '@pets-ui/icons'
import { Text } from '@pets-ui/Text/Text'
import { colors } from '@pets-ui/tokens/colors.stylex'
import { useResponsive } from '@pets-ui/useResponsive/useResponsive'
import { useHistory } from 'react-router-dom-v5'
import { useAppBar } from '../AppBar/useAppBar'

export interface AppBarAccountProps {
  onLogoutClick?: () => void
  onMyAccountClick?: () => void
}

export const AppBarAccount = (props: AppBarAccountProps) => {
  const { onLogoutClick, onMyAccountClick } = props
  const { environment } = useAppBar()
  const history = useHistory()
  const isMobile = useResponsive('mobile')
  const { campaignCodeFromUrl } = useCampaignCode()
  const { destructuredData: campaignMember } = useApiCampaignMember({ code: campaignCodeFromUrl })
  const { destructuredData: exhibitorSettings } = useApiCampaignActivityInfo(campaignCodeFromUrl)
  const isCampaignClosed = exhibitorSettings?.status && [CampaignStatus.EXPIRED, CampaignStatus.NOT_YET, CampaignStatus.PAUSED].includes(exhibitorSettings.status)
  const handleToMyAccountPage = () => {
    if (environment === 'merchant') {
      history.push(`/merchant/${campaignCodeFromUrl}/my-account/order`)
    }
    if (environment === 'campaign') {
      if (campaignMember) {
        if (isCampaignClosed) {
          history.push(`/campaigns/${campaignCodeFromUrl}/login`)
        }
        else {
          history.push(`/campaigns/${campaignCodeFromUrl}/my-account/order`)
        }
      }
      else {
        history.push(`/campaigns/${campaignCodeFromUrl}/login`, {
          referrer: isCampaignClosed ? `${window.location.origin}/campaigns/${campaignCodeFromUrl}/my-account/order` : null,
        })
      }
    }
  }

  const handleMyAccountClick = () => {
    handleToMyAccountPage()
    onMyAccountClick?.()
  }

  return (
    <HStack gap={1} alignItems="center">
      {!isMobile && <Text variant="caption" noWrap color={colors.grey600}>{campaignMember?.user_name}</Text>}
      <HStack gap={3} alignItems="center" flexWrap="nowrap">
        {onLogoutClick && campaignMember
        && (
          <ButtonBase onClick={onLogoutClick}>
            <Text variant="caption" noWrap color={colors.blue600}>(登出)</Text>
          </ButtonBase>
        )}
        <IconButton onClick={handleMyAccountClick}>
          <UserOutlined color={colors.grey900} />
        </IconButton>
      </HStack>
    </HStack>
  )
}
